import Jsonp from "@/libs/jsonp";
import { uleUrl, uleCdn, browser } from "@/libs/common";
console.log(browser().ylxdsq, "browser");
// 登录-获取短信验证码
export const sendSmsCode = (data, options, callback) => {
  return Jsonp(`//api.${uleUrl()}/ylxduser/fresh/user/sendSmsCode`, data, options, callback);
};

// 获取图形验证码
export const getCodeImage = (val, options) => {
  return Jsonp(`//api.${uleUrl()}/ylxduser/fresh/user/getCodeImage`, null, val, options);
};

// 腾讯逆向获取地址code
export const getGeocoder = (data, val, options) => {
  return Jsonp("//apis.map.qq.com/ws/geocoder/v1", data, val, options);
};

// 获取微信签名
export const getWechatSignatureApi = (data, val) => {
  return Jsonp(`//m.${uleUrl()}/wxminiapp/user/wx/getWechatSignature`, data, val, "jsonApiCallback");
};

// 获取企业微信BSC签名
export const getSdkInfoApi = (data, val) => {
  return Jsonp(`//api.${uleUrl()}/ylxduser/bsc/getSdkInfo`, data, val, "jsoncallback");
};

// 获取地图坐标两点之间的距离
export const getDistance = (data, val, options) => {
  return Jsonp("https://apis.map.qq.com/ws/distance/v1/?parameters", data, val, options);
};

// 获取首页推荐位1
export const indexDate1 = (adCode, val, option, callback) => {
  return Jsonp(`//ustatic.${uleCdn()}/yxdcdn/freshRecommend/indexTopMiniwx/jsonp1/` + adCode, option, val, callback);
};

// 获取首页推荐位2
export const indexDate2 = (adCode, val, option, callback) => {
  return Jsonp(`//ustatic.${uleCdn()}/yxdcdn/freshRecommend/indexBottom/jsonp2/` + adCode, option, val, callback);
};

// 上海保供获取首页数据   banner  goods
export const freshHomeDate = (adCode, val, option, callback) => {
  return Jsonp(`//ustatic.${uleCdn()}/yxdcdn/freshRecommend/shIndex/wap/` + adCode, option, val, callback);
};

// 获取自提点信息
export const selfPickupSiteList = (options, callback) => {
  return Jsonp(`//api.${uleUrl()}/ylxdact/fresh/act/getSHSelfPickupSiteList.do`, options, callback);
};

//获取试点城市
export const pilotCityList = (options, callback) => {
  return Jsonp(`https://api.${uleUrl()}/ylxdact/fresh/act/getFreshCitiesSelfPickupSiteList.do`, options, callback);
};
// 获取历史自提点
export const historySite = (options, callback) => {
  // return Jsonp(`https://ylxd-api.${uleUrl()}/fresh-jielong/userCommon/pickupSite/list.do`, options, callback);
  return Jsonp(`https://ylxd-api.${uleUrl()}/fresh-jielong/userCommon/site/list.do`, options, callback);
};
//获取试点城市新方法
export const pilotCityListNew = (adcode) => {
  return Jsonp(`//ustatic.${uleCdn()}/mobilead/itemRecommend/section/jsonp111/ylyx_index_city_lists_${adcode}/0`, "", "jsonp111", "jsonCallback");
};
// 找加密码-获取短信验证码
export const resetPwdSms = (options, callback) => {
  return Jsonp(`//api.${uleUrl()}/ylxduser/fresh/user/resetPwdSms`, options, callback);
};

// 重置密码
export const resetPwd = (options, callback) => {
  return Jsonp(`//api.${uleUrl()}/ylxduser/fresh/user/resetPwd`, options, callback);
};

// 机构列表
export const findChinaPostOrgUnitApi = (data, key, val) => {
  return Jsonp(`//api.${uleUrl()}/ylxduser/ylxd/chinaPostOrgUnit/findChinaPostOrgUnit.do`, data, key, val);
};

// 联合登录
export const unionLoginOrRegister = (data) => {
  return Jsonp(`//api.${uleUrl()}/ylxduser/bsc/unionLogin4Fresh.do`, data);
};

// 获取用户信息
export const getUserInfoApi = (data, key, val) => {
  return Jsonp(`//api.${uleUrl()}/ylxduser/fresh/user/getUserInfo.do`, data, key, val);
};

// 获取企业列表
export const getEntListApi = () => {
  return Jsonp(`//api.${uleUrl()}/ylxduser/ylxd/chinaPostOrgUnit/getAllEnterpriseOrgunit.do`);
};

// 修改/保存机构
export const updateUserOrgInfoApi = (data, key, val) => {
  return Jsonp(`//api.${uleUrl()}/ylxduser/user/updateUserOrgInfo.do`, data, key, val);
};

// 商品信息查询
export const getGoodsDetail = (data, options) => {
  // return Jsonp(`//ustatic.${uleCdn()}/yxdcdn/v2/item/detailFresh/jsonp3/${data}/1.html`, "", "jsonp3", options);
  return Jsonp(`//ustatic.${uleCdn()}/freshcdn/item/detailFresh/jsonp3/${data}/1.html`, "", "jsonp3", options);
};

// 商品实时库存价格信息查询
export const getGoodsAssist = (data, key, options) => {
  return Jsonp(`//m.${uleUrl()}/itemAssist/item/psl.do`, data, key, options);
};

// 商品详情查询
export const getGoodsInfo = (data, options) => {
  return Jsonp(`https://ustatic.${uleCdn()}/mobilead/v2/item/getItemDetail/jsonp6/${data}.html`, "", "jsonp6", options);
};

// 查询评论
// export const getComments = (data, options) => {
//   return Jsonp(`//item-service.${uleUrl()}/itemserviceweb/api/v1/feedback/queryCommentList`, data, "", options);
// };

// 最新 查询评论
export const getComments = (data, val) => {
  return Jsonp(`//ustatic.${uleCdn()}/mobilecommoncdn/comment/findPage/${val}/${data.listingId}/${data.pageNum}/${data.pageSize}/${data.commentImgFlag || "0"}/0`, "", val, "jsonCallback");
};

// 查询优惠券
export const queryCoupon = (data, options) => {
  return Jsonp(`//api.${uleUrl()}/ylxditem/fresh/coupon/queryCanReceiveCoupon.do`, data, "", options);
};

// 查询转增优惠券礼包
export const queryCouponGiftBagDetail = (data, options) => {
  return Jsonp(`//wallet.${uleUrl()}/wallet-pn-web/couponGiftBagController/queryCouponGiftBagDetail`, data, "", options);
};

// 领取优惠券
export const getCoupon = (data, options) => {
  return Jsonp(`//api.${uleUrl()}/ylxditem/fresh/coupon/getCoupon.do`, data, "", options);
};

// 领取转增优惠券
export const receiveCouponGiftBag = (data, options) => {
  return Jsonp(`//wallet.${uleUrl()}/wallet-pn-web/couponGiftBagController/receiveCouponGiftBag`, data, "", options);
};

// 查询客服状态
export const getKefu = (data, options) => {
  return Jsonp(`//livechat.${uleUrl()}/im/imService/custServOnlineStatu`, data, "", options);
};

// 查运费
export const checkFreight = (data, options) => {
  return Jsonp(`//checkout.${uleUrl()}/retailOrderAssist/checkFreight.do`, "", "jsonp5", options);
};

// 加入购物车
export const adCart = (data, options) => {
  return Jsonp(`//api.${uleUrl()}/ylxditem/fresh/cart/addAjax.do`, data, "", options);
};

// 查询购物车
export const checkCart = (data, options) => {
  // return Jsonp(`//api.${uleUrl()}/ylxditem/fresh/cart/getCartCount.do`, data, "", options);
  return Jsonp(`//m.${uleUrl()}/mxiaodian/cart/getCartCountFresh.do`, data, "", options);
};

// 查询小店app分享链接
export const getAppShareURL = (data, options) => {
  return Jsonp(`//api.${uleUrl()}/ylxditem/item/shareListingURL`, data, "", options);
};
// 获取商品分享图片接口
export const getShareImg = (params) => {
  return Jsonp(`//api.${uleUrl()}/ylxditem/item/getJsonItem.do`, params, "jsoncallback", "");
};
// APP分享
export const getShareURL = (data, options) => {
  return Jsonp(`//api.${uleUrl()}/ylxditem/item/getShareURL.do`, data, "", options);
};

//删除购物车
export const deleteCart = (data, options) => {
  // return Jsonp(`//api.${uleUrl()}/ylxditem/fresh/cart/del`, data, "", options);
  return Jsonp(`//api.${uleUrl()}/ylxditem/fresh/cart/cartDel`, data, "", options);
};

// 搜索
export const findListing = (query, val, option) => {
  return Jsonp(`//api.${uleUrl()}/ylxditem/fresh/item/findListing`, query, val, option);
};

// 购物车列表
export const getCartList = (data, options) => {
  return Jsonp(`//api.${uleUrl()}/ylxditem/fresh/cart/list`, data, "", options);
};

// 试点城市购物车列表
export const getPilotCityCartList = (data, options) => {
  // app试点
  if(browser().ulemax){
    console.log('购物车列表')
    return Jsonp(`//api.${uleUrl()}/ylxditem/fresh/cart/cartList`, data, "", options);
  }else{
    return Jsonp(`//api.${uleUrl()}/ylxditem/fresh/cart/pilotCityList`, data, "", options);
  }
};

// 购物车列表
export const editCart = (data, options) => {
  return Jsonp(`//api.${uleUrl()}/ylxditem/fresh/cart/mod`, data, "", options);
};

// 分类列表
export const findingFreshCategory = (data, options) => {
  return Jsonp(`//api.${uleUrl()}/ylxditem/fresh/item/findingFreshCategory.do`, data, "", options);
};

// 获取用户userId
export const getUserId = (options) => {
  return Jsonp(`//my.${uleUrl()}/usr/getIndexCookies.do`, "", "", options);
};

// 获取自提点
export const getStoreSelfExtract = (data, options) => {
  return Jsonp(`//api.${uleUrl()}/ylxduser/fresh/user/getStoreSelfExtract`, data, "", options);
};

// 自提点下的订单
export const getZtOrder = (data, options) => {
  return Jsonp(`//api.${uleUrl()}/appxiaodian/fresh/order/zitiList`, data, "", options);
};

// 获取所有商家列表
export const getMerchantList = (data, options) => {
  return Jsonp(`//api.${uleUrl()}/appxiaodian/fresh/order/merchantList`, data, "", options);
};

// 获取所有接龙列表
export const getJielongActList = (data, options) => {
  return Jsonp(`//api.${uleUrl()}/appxiaodian/fresh/order/jielongActList.do`, data, "", options);
};

// 邀请注册获取验证码
export const regIsTer = (data, options) => {
  return Jsonp(`//api.${uleUrl()}/ylxduser/sms/h5/register.do`, data, "", options);
};

// 邀请注册注册接口
export const quickRegister = (data, options) => {
  return Jsonp(`//api.${uleUrl()}/ylxduser/user/h5/quickRegister.do`, data, "", options);
};

// 获取自提订单详情内容
export const getOrderDetails = (data, options) => {
  return Jsonp(`//api.${uleUrl()}/appxiaodian/order/detail.do`, data, options);
};

// 发送自提短消息
export const sendMsgRemind = (data, options) => {
  return Jsonp(`//api.${uleUrl()}/ylxduser/fresh/order/arrivalRemind`, data, options);
};

// 获取接龙活动信息已发布
export const queryXcxItemByActId = (data, options) => {
  return Jsonp(`https://ustatic.${uleCdn()}/freshcdn/fresh/act/queryXcxItemByActId/jsonp21111/${data}`, "", "jsonp21111", options);
};

// 获取接龙活动信息未发布
export const queryXcxNoPubItemByActIdApi = (data, options) => {
  // return Jsonp(`https://ustatic.${uleCdn()}/yxdcdn/fresh/act/queryXcxNoPubItemByActId/jsonp21/${data}`, "", "jsonp21", options);
  return Jsonp(`https://ustatic.${uleCdn()}/freshcdn/fresh/act/queryXcxNoPubItemByActId/jsonp21/${data}`, "", "jsonp21", options);
};

// 广告推荐位获取接龙优惠券活动code
export const recommend = (data, options) => {
  // return Jsonp(`//ustatic.${uleCdn()}/mobilead/itemRecommend/sectionList/getTmplSection1/${data.sectionKeys}/0?${data.time}`, "", "getTmplSection1", options);
  return Jsonp(`//ustatic.${uleCdn()}/common-recommend-cdn/itemRecommend/sectionList/getTmplSection1/${data.sectionKeys}/0?${data.time}`, "", "getTmplSection1", options);
};
// 获取接龙优惠券信息
export const queryCouponList = (data) => {
  return Jsonp(`https://ustatic.${uleCdn()}/activity-cdn/couponController/queryCouponList/getTmplData/${data}`, "", "getTmplData", "jsonpCallBack");
};
// 领取优惠券
export const receiveCoupon = (data, options) => {
  return Jsonp(`https://service.${uleUrl()}/activity-web-service/couponController/receiveCoupon`, data, "jsonp1", options);
};
// 获取接龙活动信息结束后
export const getSalesInfo = (data, options) => {
  return Jsonp(`https://ustatic.${uleCdn()}/yxdcdn/fresh/act/getSalesInfo/jsonp22/${data}`, "", "jsonp22", options);
};

// 获取接龙活动购买记录
export const getPurchaseRecord = (data, options) => {
  // return Jsonp(`https://api.${uleUrl()}/ylxdact/fresh/act/getPurchaseRecord.do`, data, "jsonp23", options);
  // return Jsonp(`https://ustatic.${uleCdn()}/mobilecommoncdn/fresh/act/getPurchaseRecord/jsonp123/${data.activityCode}/${data.shareUserId || '_'}/${data.pageIndex}/${data.pageSize}`, data, "jsonp123", options);
  return Jsonp(`https://ustatic.${uleCdn()}/freshcdn/fresh/act/getPurchaseRecord/jsonp123/${data.activityCode}/${data.shareUserId || '_'}/${data.pageIndex}/${data.pageSize}`, data, "jsonp123", options);
};

// 店铺信息
export const storeDetail = (data, options) => {
  return Jsonp(`//ustatic.${uleCdn()}/mobilead/v2/store/searchUleStoreInfo/jsonp4/${data}/1`, "", "jsonp4", options);
};

// 店铺热销商品
export const storeGoods = (data, options) => {
  return Jsonp(`//api.${uleUrl()}/ylxditem/fresh/item/findListing.do`, data, "", options);
};

// 个人自提点列表
export const getSelfPickupSiteList = (data, options) => {
  return Jsonp(`//api.${uleUrl()}/ylxduser/address/selfSite/getSelfPickupSiteList`, data, "", options);
};

// 查询手机号是否是邮乐网用户
export const isUleUser = (data, options) => {
  return Jsonp(`//api.${uleUrl()}/ylxduser/user/isUleUser`, data, "", options);
};

// 新增修改自提点
export const savaAndUpdate = (data, options) => {
  return Jsonp(`//api.${uleUrl()}/ylxduser/address/selfSite/savaAndUpdate`, data, "", options);
};

// 删除个人自提点
export const removeBySiteId = (data, options) => {
  return Jsonp(`//api.${uleUrl()}/ylxduser/address/selfSite/removeBySiteId`, data, "", options);
};

// 根据id查询自提点详情
export const queryBySiteId = (data, options) => {
  return Jsonp(`//api.${uleUrl()}/ylxduser/address/selfSite/queryBySiteId`, data, "", options);
};

// 订单列表
export const getOrderList = (data, key) => {
  return Jsonp(`//api.${uleUrl()}/appxiaodian/fresh/order/list`, data, "", key);
};
// 订单详情
export const queryOrderDetail = (data, options) => {
  return Jsonp(`//ylxd-api.${uleUrl()}/ylxdorder/order/orderDetail`, data, "", options);
};

// 个人中心查询订单数目
export const getOrderNumByStatus = (data, key) => {
  return Jsonp(`//api.${uleUrl()}/appxiaodian/order/getOrderNumByStatus`, data, "", key);
};

// 查用户信息接口
export const getUserBaseInfo = (data, key) => {
  return Jsonp(`//api.${uleUrl()}/ylxduser/user/getUserBaseInfo.do`, data, "", key);
};

// 用户收货地址列表接口
export const getAddressList = (data, key) => {
  return Jsonp(`//api.${uleUrl()}/ylxduser/address/list.do`, data, "", key);
};

// 用户收货地址详情接口
export const getAddressDetail = (data, key) => {
  return Jsonp(`//api.${uleUrl()}/ylxduser/address/detail.do`, data, "", key);
};
// 用户添加收货地址接口
export const getAddAddress = (data, key) => {
  return Jsonp(`//api.${uleUrl()}/ylxduser/address/add.do`, data, "", key);
};
// 删除收货地址接口
export const getDelAddress = (data, key) => {
  return Jsonp(`//api.${uleUrl()}/ylxduser/address/del.do`, data, "", key);
};
// 修改收货地址接口
export const getUpdateAddress = (data, key) => {
  return Jsonp(`//api.${uleUrl()}/ylxduser/address/update.do`, data, "", key);
};
// 设置默认地址接口
export const setDefaultAddress = (data, key) => {
  return Jsonp(`//m.${uleUrl()}/address/def/${data}`, "", "", key);
};

// 取消订单
export const cancelOrder = (data, key) => {
  return Jsonp(`//ylxd-api.${uleUrl()}/ylxdorder/order/cancelOrder`, data, "", key);
};

// 确认签收
export const waitSignOrder = (data, key) => {
  return Jsonp(`//ylxd-api.${uleUrl()}/ylxdorder/order/confirmWaitSignOrder`, data, "", key);
};

// 立即付款;
export const orderPay = (data) => {
  return Jsonp(`//api.${uleUrl()}/yzgApiWAR/ylxd/pay/orderPay.do`, data, "", "");
};

// 删除订单
export const deleteOrder = (data, key) => {
  return Jsonp(`//ylxd-api.${uleUrl()}/ylxdorder/order/deleteOrder`, data, "", key);
};
// 获取自提点信息
export const getSiteContact = (data, key) => {
  return Jsonp(`//ylxd-api.${uleUrl()}/fresh-jielong/site/getSiteContact.do`, data, "", key);
};

// 获取用户优惠券列表
export const userCoupon = (data, key) => {
  // return Jsonp(`//api.${uleUrl()}/ylxditem/store/listingCoupon`, data, "", key);
  return Jsonp(`//ylxd-api.${uleUrl()}/ylxdwallet/fresh/coupon/listingCoupon`, data, "", key);
};

// 发货提醒
export const deliverReminder = (data, key) => {
  return Jsonp(`//ylxd-api.${uleUrl()}/ylxdorder/order/deliverReminder`, data, "", key);
};

// 获取省
export const getProvinces = (key) => {
  return Jsonp(`//ustatic.${uleCdn()}/mobilead/v2/address/getProvinces/h5.html`, "", "jsonp21", key);
};

// 获取市
export const getCities = (data, key) => {
  return Jsonp(`//ustatic.${uleCdn()}/mobilead/v2/address/getCities/h5/${data}/2.html`, "", "jsonp21", key);
};

// 获取区
export const getAreas = (data, key) => {
  return Jsonp(`//ustatic.${uleCdn()}/mobilead/v2/address/getAreas/h5/${data}/3.html`, "", "jsonp21", key);
};

// 获取街道
export const getTowns = (data, key) => {
  return Jsonp(`//ustatic.${uleCdn()}/mobilead/v2/address/getTowns/h5/${data}/4.html`, "", "jsonp21", key);
};

// 查询物流
export const expressSearch = (data, key) => {
  return Jsonp(`//ylxd-api.${uleUrl()}/ylxdorder/order/expressSearch`, data, "", key);
};

// 查询活动场次信息
export const getActivityInfos = (data, key) => {
  return Jsonp(`//ustatic.${uleCdn()}/yxdcdn/v2/act/redenvelopes/getActivityInfos/jsonp7/300000/${data}`, "", "jsonp7", key);
};

// 抽奖
export const lottry = (data, key) => {
  return Jsonp(`//service.${uleUrl()}/lottry/lottery/lottry`, data, "", key);
};

// 获取取消订单理由
export const indexFeaturedGet = (key) => {
  return Jsonp(`//ustatic.${uleCdn()}/mobilead/v2/recommend/indexFeaturedGet/jsonp22/0/ule_cancel_reason_new/null/null/null/null/null.html`, "", "jsonp22", key);
};

// 接龙优惠券
export const batchQueryCanReceiveCouponApi = (data) => {
  return Jsonp(`//m.${uleUrl()}/mact/coupon/batchQueryCanReceiveCoupon`, data, "", "jsonCallback");
};

// 判断登录人是否是新人接口
export const isNewUser = (params) => {
  return Jsonp(`//api.${uleUrl()}/ylxduser/fresh/user/isNewUser.do`, params, "", "jsonCallback");
};

// 获取优鲜改版首页banner图信息
export const getNewIndexBanner = (adCode) => {
  return Jsonp(`//ustatic.${uleCdn()}/yxdcdn/freshRecommend/newIndexBanners/H5/` + adCode, "", "H5", "jsonCallback");
};
// 获取优鲜改版首页banner图信息
export const getIndexBanner2 = (params) => {
  return Jsonp(`//ustatic.${uleCdn()}/yxdcdn/freshRecommend/pilotCityIndexBanner/jsonp25/${params.key}/1/10/${params.adcode}`, "", "jsonp25", "jsonCallback");
};

//新人专享礼2商品
export const activityNew = (params) => {
  return Jsonp(`//service.${uleUrl()}/appact/prizeYth/queryItemByActivityCategory`, params, "", "");
};

//试点城市
export const PilotCity = () => {
  return Jsonp(`//ustatic.${uleCdn()}/yxdcdn/freshRecommend/newIndexCities/jsoncallback123`, "", "jsoncallback123", "jsonCallback");
};

//试点城市BANNER
export const getPilotCityMiddleBanners = (adCode) => {
  return Jsonp(`//ustatic.${uleCdn()}/yxdcdn/freshRecommend/pilotCityIndexMiddleBanners/json235/1/50/` + adCode, "", "json235", "jsonCallback");
};

//每日爆品接口
export const DayHotGood = (adCode) => {
  return Jsonp(`//ustatic.${uleCdn()}/yxdcdn/freshRecommend/newIndexDailyListings/json234/` + adCode, "", "json234", "jsonCallback");
};

//限时秒杀商品
export const SecKillGood = (params) => {
  // return Jsonp(`//service.${uleUrl()}/appact/prizeYth/queryYthThemeActivityInfoList`, params, "", "");
  return Jsonp(`//fresh-api.${uleUrl()}/fresh-act/fresh/act/queryYthThemeActivityInfoList.do`, params, "", "");
};

//获取优惠券批次号，活动code，主题code
export const acvtivityInfo = (adCode, params) => {
  return Jsonp(`//ustatic.${uleCdn()}/yxdcdn/freshRecommend/newIndexCodes/json123/` + adCode, params, "json123", "jsonCallback");
};

//查询优惠券
export const serchCoupon = (params) => {
  return Jsonp(`//service.${uleUrl()}/couponquery-web-service/couponWallCipherController/searchCouponWall`, params, "callback", "jsoncallback");
};

export const getAllCoupon = (params) => {
  return Jsonp(`//service.${uleUrl()}/activity-web-service/couponController/batchReceiveCoupon`, params, "callback", "jsoncallback");
};

// 判断登录人是否是新人接口,不带资格
export const isNewUserForVI = () => {
  return Jsonp(`//api.${uleUrl()}/ylxduser/fresh/user/isNewUserForVI.do`, "", "", "jsonCallback");
};

//更新最后一次自提点信息
export const addOrUpdateApi = (params) => {
  // return Jsonp(`//ylxd-api.${uleUrl()}/fresh-jielong/userCommon/pickupSite/addOrUpdate.do`, params, "callback", "jsoncallback");
  return Jsonp(`//ylxd-api.${uleUrl()}/fresh-jielong/userCommon/site/addOrUpdate.do`, params, "callback", "jsoncallback");
};

// 获取最新一次自提点
export const getIndexDefSiteApi = (params) => {
  // return Jsonp(`//ylxd-api.${uleUrl()}/fresh-jielong/userCommon/pickupSite/getIndexDefSite.do`, params, "", "");
  return Jsonp(`//ylxd-api.${uleUrl()}/fresh-jielong/userCommon/site/getIndexDefSite.do`, params, "", "");
};

// 查询商品在购物车中的数量
export const getCartItemByIdApi = (params, options) => {
  return Jsonp(`//api.${uleUrl()}/ylxditem/fresh/cart/getCartItemById`, params, "", options);
};

// 团长端

// 退货清单
export const returnTakeListApi = () => {
  return Jsonp(`//my.${uleUrl()}/myReturnOrderWapWeb/fresh/collect/returnTakeList.do`, "", "", "callback");
  // return Jsonp(`//192.168.113.151:8080/myReturnOrderWapWeb/fresh/collect/returnTakeList.do`,"","","callback")
};

// 退货订单
export const returnTakeDetailApi = (params) => {
  return Jsonp(`//my.${uleUrl()}/myReturnOrderWapWeb/fresh/collect/returnTakeDetail.do`, params, "", "callback");
  // return Jsonp(`//192.168.113.151:8080/myReturnOrderWapWeb/fresh/collect/returnTakeDetail.do`,params,"","callback")
};

// 司机取货明细
export const driverTakeDetailApi = (params) => {
  return Jsonp(`//my.${uleUrl()}/myReturnOrderWapWeb/fresh/collect/driverTakeDetail.do`, params, "", "callback");
  // return Jsonp(`//192.168.113.151:8080/myReturnOrderWapWeb/fresh/collect/driverTakeDetail.do`,params,"","callback")
};

// 取货照片
export const driverTakeImgsApi = (params) => {
  return Jsonp(`//my.${uleUrl()}/myReturnOrderWapWeb/fresh/collect/driverTakeImgs.do`, params, "", "callback");
  // return Jsonp(`//192.168.113.151:8080/myReturnOrderWapWeb/fresh/collect/driverTakeImgs.do`,params,"","callback")
};

// 下单人数，下单商品数量查搜索
export const chainsInfoApi = (params) => {
  // return Jsonp(`//api.${uleUrl()}/appxiaodian/fresh/order/chainsInfo.do`, params, "", "jsonCallback");
  return Jsonp(`//ustatic.${uleCdn()}/freshcdn/fresh/act/chainsInfo/jsonp3333/${params.actCode}`, "", "jsonp3333");
};

// 个人中心金额
export const personalCenterInfoApi = (params) => {
  return Jsonp(`//service.${uleUrl()}/appuser/miniwxUleCard/getPersonalCenterInfo.do`, params, "", "jsonApiCallback");
};

// 首页弹窗
export const freshHomePopApi = (params) => {
  return Jsonp(`//m.${uleUrl()}/mobileact/userAct/freshHomePop`, params, "", "jsonCallBack");
};

// 抽取红包
export const lottryV2Api = (params) => {
  return Jsonp(`//service.${uleUrl()}/lottry/lottery/lottryV2`, params, "", "jsoncallback");
};

// 邮掌柜-接龙列表-自己发布
export const qrySelfChainsApi = (params) => {
  if (browser().ylxdsq || browser().ulemax) {
    return Jsonp(`//api.${uleUrl()}/ylxdact/fresh/act/qrySelfChains.do`, params, "", "jsoncallback");
  } else {
    return Jsonp(`//api.${uleUrl()}/ylxdact/yzg/fresh/qrySelfChains.do`, params, "", "jsoncallback");
  }
};

// 邮掌柜-接龙列表-我帮卖的
export const qrySaleChainsApi = (params) => {
  if (browser().ylxdsq || browser().ulemax) {
    return Jsonp(`//api.${uleUrl()}/ylxdact/fresh/act/qrySaleChains.do`, params, "", "jsoncallback");
  } else {
    return Jsonp(`//api.${uleUrl()}/ylxdact/yzg/fresh/qrySaleChains.do`, params, "", "jsoncallback");
  }
};

// 邮掌柜-接龙列表-删除接龙
export const delChainApi = (params) => {
  if (browser().ylxdsq || browser().ulemax) {
    return Jsonp(`//api.${uleUrl()}/ylxdact/fresh/act/delChain.do`, params, "", "jsoncallback");
  } else {
    return Jsonp(`//api.${uleUrl()}/ylxdact/yzg/fresh/delChain.do`, params, "", "jsoncallback");
  }
};

// 邮掌柜-接龙列表-结束接龙
export const closeChainApi = (params) => {
  if (browser().ylxdsq || browser().ulemax) {
    return Jsonp(`//api.${uleUrl()}/ylxdact/fresh/act/closeChain.do`, params, "", "jsoncallback");
  } else {
    return Jsonp(`//api.${uleUrl()}/ylxdact/yzg/fresh/closeChain.do`, params, "", "jsoncallback");
  }
};

// 邮掌柜-发布接龙
export const chainsPublishApi = (params) => {
  return Jsonp(`//api.${uleUrl()}/ylxdact/yzg/fresh/chainsPublish.do`, params, "", "jsoncallback");
};

// 优鲜app-已分享列表
export const myShareJielongActListApi = (params) => {
  return Jsonp(`//api.${uleUrl()}/appxiaodian/fresh/order/myShareJielongActList.do`, params, "", "jsonCallback");
};

// 优鲜app-订单数量
export const jieLongOrderStatApi = (params) => {
  return Jsonp(`//api.${uleUrl()}/appxiaodian/fresh/order/jieLongOrderStat.do`, params, "", "jsonCallback");
};

// 优鲜app-导出订单明细
export const exportJieLongOrderApi = (params) => {
  return Jsonp(`//api.${uleUrl()}/appxiaodian/fresh/order/exportJieLongOrder.do`, params, "", "jsonCallback");
};

// 优鲜app-帮卖列表
export const qrySalesAndOrgChainsApi = (params) => {
  return Jsonp(`//api.${uleUrl()}/ylxdact/fresh/act/qrySalesAndOrgChains.do`, params, "", "jsoncallback");
};

// 销售数据-店铺
// export const achievementCenterApi = (params) => {
//   return Jsonp(`//ylxd-api.${uleUrl()}/ylxdwallet/user/achievementCenter`, params, "", "jsoncallback");
// };

// 自提订单查询物流
export const latestExpressSearchApi = (params) => {
  return Jsonp(`//ylxd-api.${uleUrl()}/ylxdorder/fresh/order/latestExpressSearch`, params, "", "jsonCallback");
};

// 销售数据-累计销售数据
export const salesInfoAfterApi = (params) => {
  return Jsonp(`//ylxd-api.${uleUrl()}/ylxdwallet/fresh/user/salesInfoAfter`, params, "", "jsoncallback");
};

// 创业收入
export const tradingInfoApi = (params) => {
  return Jsonp(`//ylxd-api.${uleUrl()}/ylxdwallet/user/tradingInfo`, params, "", "jsoncallback");
};

// 创业收入列表
export const incomeSourceInfoApi = (params) => {
  return Jsonp(`//ylxd-api.${uleUrl()}/ylxdwallet/fresh/user/incomeSourceInfo`, params, "", "jsoncallback");
};

// 顾客统计
export const freshCustomerStatisticsApi = (params) => {
  return Jsonp(`//service.${uleUrl()}/appxiaodian/freshStoreAdvise/freshCustomerStatistics`, params, "", "jsoncallback");
};

// 我的推荐
export const freshCustomerListApi = (params) => {
  return Jsonp(`//service.${uleUrl()}/appxiaodian/freshStoreAdvise/freshCustomerList`, params, "", "jsoncallback");
};

// 销售数据
export const salesInfoApi = (params) => {
  return Jsonp(`//ylxd-api.${uleUrl()}/ylxdwallet/fresh/user/salesInfo`, params, "", "jsoncallback");
};

// 顾客店铺数据
export const freshAdviserStatisticsApi = (params) => {
  return Jsonp(`//service.${uleUrl()}/appxiaodian/freshStoreAdvise/freshAdviserStatistics`, params, "", "jsoncallback");
};

// 顾客店铺列表
export const freshAdviserListApi = (params) => {
  return Jsonp(`//service.${uleUrl()}/appxiaodian/freshStoreAdvise/freshAdviserList`, params, "", "jsoncallback");
};

// 创业收益
export const incomeInfoApi = (params) => {
  return Jsonp(`//ylxd-api.${uleUrl()}/ylxdwallet/fresh/user/incomeInfo`, params, "", "jsoncallback");
};

// 店主天地
export const getVideoArticlesByChannelCateApi = (params) => {
  return Jsonp(
    `https://ustatic.${uleCdn()}/yxdcdn/v2/recommend/getVideoArticlesByChannelCate/jsonp1/${params.pageNum}/${params.pageSize}/1/${params.channel}/${params.showCategory}`,
    "",
    "jsonp1",
    "jsonCallback"
  );
};

// 当前登录人是否有自提点
export const qryYlxdSqSelfPickupSitesApi = (params) => {
  return Jsonp(`https://api.${uleUrl()}/ylxdact/fresh/act/qryYlxdSqSelfPickupSites.do`, "", "jsonp1", "jsoncallback");
};

// 详情加容联接口
export const getRongLianUrlApi = (params) => {
  return Jsonp(`https://ustatic.${uleCdn()}/mobilecommoncdn/kefu/queryMerchantKfType1/ultjsonp/${params.merchantId}/${params.storeId}`, "","ultjsonp", "callback");
};

// 拉新注册页推荐位
export const getNewDataApi = () => {
  return Jsonp(`//ustatic.${uleCdn()}/mobilead/v2/recommend/dwRecommond/getNewData/2002/0/null/laxin_register_ylxdsq.html`, "", "getNewData", "");
};
// 注册完成查券接口
export const getNewGiftApi = (params) => {
  return Jsonp(`//api.${uleUrl()}/ylxdact/userAct/queryCouponGift`, params, "ylyx", "jsonCallBack");
};

// 接龙分类
export const qryXcxItemPubCatByActIdApi = (params) => {
  return Jsonp(`//api.${uleUrl()}/ylxdact/fresh/act/qryXcxItemPubCatByActId.do`, params, "", "jsoncallback");
};

// 分类商品
export const findXcxItemPubByConditionApi = (params) => {
  return Jsonp(`//api.${uleUrl()}/ylxdact/fresh/act/v2/findXcxItemPubByCondition.do`, params, "", "jsoncallback");
};

// 优鲜app上海白名单判断
export const specificStaffApi = (params) => {
  return Jsonp(`//api.${uleUrl()}/ylxdact/userAct/specificStaff.do`, params, "", "jsonCallBack");
};

// 加容联登录cookiejsonCallback
export const setKefuCookie  = () => {
  return Jsonp(`https://m.${uleUrl()}/muser/customService/syncKefuInfo`, "","jsonp221", "jsonCallback");
};
//浮层展示数据接口
export const viPopFor919Api = (params) => {
  return Jsonp(`//api.${uleUrl()}/ylxdact/userAct/viPopFor919?`,params,'','jsonCallBack')
}

// 根据活动code和用户id查询资格
export const queryQualificationByActCodeAndUserId = (params)=>{
  return Jsonp(`https://m.${uleUrl()}/mobileact/newUserPrize/querySeckillQualifi`,params,'','jsonCallback')
}

// 首页浮标
export const freshPopAndFloatApi = (params) => {
  return Jsonp(`https://api.${uleUrl()}/ylxdact/userAct/freshPopAndFloat`,params,"jsonCallBack","jsonCallBack");
};
// 红包雨浮层
export const queryActCodeByUsrRoleAndThemeCodeApi = params => {
  return Jsonp(`https://service.${uleUrl()}/appact/redenvelopes/queryCurRedenvelopesInfo`,params,"jsoncallback");
};

// 红包雨2 
export const queryActCodeByThemeCodeApi = (params) => {
  return Jsonp(`https://service.${uleUrl()}/appact/redenvelopes/queryCurRedenvelopesInfo`,params,"jsoncallback");
};
// 红包雨根据主题code查询对应的活动信息
export const queryRedenvelopesInfo = params => {
  return Jsonp(`https://service.${uleUrl()}/appact/redenvelopes/queryRedenvelopesInfo`,params,"jsoncallback");
};

// 优惠券-领取-批量(加密)外网
export const receiveCouponsApi = (params) => {
  return Jsonp(`https://service.${uleUrl()}/coupontrans-web-service/couponReceiveController/receiveCoupons`,params,"jsoncallback");
};

// 获取手机广告推荐位
export const getRecommendInfoByKey = (params) => {
  return Jsonp(`https://ustatic.${uleCdn()}/mobilead/v2/recommend/indexFeaturedGet/${params.key}/1/${params.key}`, "", params.key, "jsoncallback");
};

// 判断新老用户(7次资格)
export const isShowPayTips = () => {
  return Jsonp(`https://m.${uleUrl()}/mobileact/newUserPrize/isShowPayTips`, "", "", "jsonCallback");
};

// 获取自提点信息
export const ylyxGetGroupIdListByBdId = (params, callback) => {
  return Jsonp(`//api.${uleUrl()}/ylxdact/fresh/act/ylyxGetGroupIdListByBdId.do`, params, callback);
};

// 获取规则
export const rulesinfo = (id) => {
  return Jsonp(`//item.${uleUrl()}/activity/getTmplPage/1-${id}.html`, '', 'getTmplPage');
};

// 商品信息查询APP
export const getGoodsDetailApp = (data,freshActType,options) => {
  if(freshActType == true){
    return Jsonp(`//ustatic.${uleCdn()}/yxdcdn/v2/item/detailPilotCity/jsonp3/${data.listingId}/1/${data.deliveryAreaId}.html`, "", "jsonp3", options);
  }else{
    return Jsonp(`//ustatic.${uleCdn()}/yxdcdn/v2/item/detail2/jsonp3/${data.listingId}/1.html`, "", "jsonp3", options);
  }
};

export const actPslApi = params => {
  return Jsonp( `https://m.${uleUrl()}/itemAssist/item/actPsl.do`, params, '', "jsonCallback");
};

// 接龙各自推荐位
export const provinceBannerApi = (params) => {
  return Jsonp(`https://ustatic.${uleCdn()}/freshcdn/freshRecommend/provinceChainBanner/jsonp44123/ylyx_province_chain_banner/${params.province}/${params.adcode}/${params.areaCode}`, "", 'jsonp44123', "jsoncallback");
  // return Jsonp(`https://ustatic.${uleCdn()}/freshcdn/freshRecommend/provinceChainBanner/jsonp44123/ylyx_province_chain_banner/430000/430100/null`, "", 'jsonp44123', "jsoncallback");
};

// 获取微信签名
export const getWechatSignatureApi2 = (data, val) => {
  return Jsonp(`//service.ule.com/api/mobile/getWechatSignature.do`, data, val, "jsonApiCallback");
};
export const getStoreInfoApi = (params) => {
  return Jsonp(`https://api.${uleUrl()}/ylxduser/fresh/user/getStoreInfo`, params, '','jsoncallback');
};

// 浮条信息
export const freshFloatStripApi = (params) => {
  return Jsonp(`https://ylxd-api.${uleUrl()}/xiaodian-pop/fresh/freshFloatStrip`, params, '','jsonCallBack');
};

export const getActBanner = (params, callback, val) => {
  return Jsonp(`//ustatic.${uleCdn()}/mobilead/v2/recommend/getMobileRecommond/wanRen1Gro1u1p/ylyx_vi_banner`, "", "wanRen1Gro1u1p", "jsoncallback");
};

// 声明与提醒
export const shengmingTixingApi = () => {
  return Jsonp(`//ustatic.${uleCdn()}/mobilead/v2/recommend/dwRecommond/jsonp26/2002/0/null/vi_shengmingTixing.html`, "", "jsonp26", "jsonp26");
};

// 延迟发货
export const delayOrderApi = (params) => {
  return Jsonp(`https://api.${uleUrl()}/appxiaodian/order/delaySign`, params, '','jsoncallback');
};
// 查询收货信息
export const writeOffInfo = (params) => {
  return Jsonp(`https://service.${uleUrl()}/aftersale-assist/freshWriteOff/writeOffInfo`, params, '','jsonCallback');
};
// 签收
export const updateWriteOffStatus =`https://service.${uleUrl()}/aftersale-assist/freshWriteOff/updateWriteOffStatus`
// 保存自提点
export const selectedSelfSite = (params) => {
  return Jsonp(`https://ylxd-api.${uleUrl()}/fresh-jielong/site/selectedSelfSite.do`, params, '','jsoncallback');
};
// 查询自提点
export const getStoreSelfExtract2 = (params) => {
  return Jsonp(`https://ylxd-api.${uleUrl()}/fresh-jielong/site/getStoreSelfExtract.do`, params, '','jsoncallback');
};
// 批量审核
export const batchVerification = (params) => {
  return Jsonp(`https://api.${uleUrl()}/appxiaodian/fresh/order/batchVerification.do`, params, '','jsonCallback');
};